import * as z from "zod/v4";

export const getShopifyPermissionsUpdateUrl = {
  name: "getShopifyPermissionsUpdateUrl" as const,
  input: z.object({ nextPath: z.string() }),
  output: z.object({ authorizationUrl: z.string() }),
};
